import { Component, NgZone } from '@angular/core';
import { NavController, NavParams, PopoverController, Events } from 'ionic-angular';
import { Http, ResponseContentType } from "@angular/http";
import { EbsWebService } from "../../services/ebsWebService";
import { SharePdfPopover } from "../../popovers/share-pdf/share-pdf";

@Component({
  selector: 'page-pdf-viewer',
  templateUrl: 'pdf-viewer.html'
})
export class PdfViewerPage {

  title: any;
  pageLoaded: boolean = false;
  pdfSrc: Uint8Array;
  printPdfSrc: Uint8Array;
  downloadPdfSrc: Uint8Array;

  constructor(public navCtrl: NavController, public popoverCtrl: PopoverController, public events: Events, public navParams: NavParams, private http: Http, public ngZone: NgZone, public _ebsWebService: EbsWebService) {
    this.title = navParams.get('title');

    //events.publish("reloadMenu");

    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
    this._ebsWebService.postData(this.navParams.get('actionURL'), postPayloadObject).subscribe(element => {
      this.ngZone.run(() => {
        this.pdfSrc = element.DownloadURL;//new Uint8Array(file.arrayBuffer());
        this.printPdfSrc = element.PrintURL;
        this.downloadPdfSrc = element.SaveAsUrl;
      });
    });
  }

  loaded() {
    this.pageLoaded = true;
  }

  printPdf(pdfUrl) {
    console.log(pdfUrl);
    let url = pdfUrl;
    this.http.get(url, { responseType: ResponseContentType.Blob }).subscribe((response) => {
      var blob = new Blob([response.blob()], { type: 'application/pdf' });
      console.log(blob);
      const blobUrl = URL.createObjectURL(blob);
      const iframe = document.createElement('iframe');
      console.log(iframe);
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    });
  }

  sharePopover(myEvent, pdfData) {
    let popover = this.popoverCtrl.create(SharePdfPopover, { pdfData: pdfData });
    popover.present({
      ev: myEvent
    });
  }

  downloadPdf(pdfUrl) {
    window.open(pdfUrl);
  }
}



// WEBPACK FOOTER //
// ./src/pages/pdf-viewer/pdf-viewer.ts